import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ArrowRight, X } from 'lucide-react';
const CHECKOUT_URL = 'https://pay.hotmart.com/G105750225G?off=exnypaed';
export function FloatingCTA() {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);
  const [isOfferInView, setIsOfferInView] = useState(false);
  const [isExitPopupOpen, setIsExitPopupOpen] = useState(false);
  // Show after user scrolls past the hero
  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll, {
      passive: true
    });
    handleScroll();
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  // Hide when the actual offer section is visible (avoid duplication)
  useEffect(() => {
    const offerEl = document.getElementById('offer');
    if (!offerEl) return;
    const observer = new IntersectionObserver(([entry]) => setIsOfferInView(entry.isIntersecting), {
      threshold: 0.2
    });
    observer.observe(offerEl);
    return () => observer.disconnect();
  }, []);
  // Hide when the exit-intent popup is open (avoid stacking and visual clash)
  useEffect(() => {
    const handleOpen = () => setIsExitPopupOpen(true);
    const handleClose = () => setIsExitPopupOpen(false);
    window.addEventListener('exit-popup-open', handleOpen);
    window.addEventListener('exit-popup-close', handleClose);
    return () => {
      window.removeEventListener('exit-popup-open', handleOpen);
      window.removeEventListener('exit-popup-close', handleClose);
    };
  }, []);
  const shouldShow = isVisible && !isDismissed && !isOfferInView && !isExitPopupOpen;
  return <AnimatePresence data-id="element-79">
      {shouldShow && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      duration: 0.4,
      ease: [0.16, 1, 0.3, 1]
    }} className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:bottom-6 z-[90] flex justify-center md:justify-end pointer-events-none pb-[env(safe-area-inset-bottom)]" data-id="element-80">
          <div className="relative pointer-events-auto w-full md:w-auto max-w-md" data-id="element-81">
            {/* Pulsing glow ring */}
            <motion.div animate={{
          opacity: [0.3, 0.6, 0.3],
          scale: [1, 1.04, 1]
        }} transition={{
          duration: 2.4,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="absolute inset-0 bg-blood/40 blur-xl rounded-[2px] -z-10" aria-hidden="true" data-id="element-82" />

            <motion.a href={CHECKOUT_URL} target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.02
        }} whileTap={{
          scale: 0.98
        }} className="group flex items-center gap-3 md:gap-4 bg-blood text-white py-3 md:py-3.5 pl-5 pr-4 md:pl-6 md:pr-5 rounded-[2px] shadow-[0_8px_30px_rgba(184,20,28,0.5)] no-underline w-full md:w-auto" data-id="element-83">
              <div className="flex flex-col items-start min-w-0 flex-1 md:flex-initial" data-id="element-84">
                <span className="font-sans text-[10px] md:text-[11px] uppercase tracking-widest text-white/80 leading-tight" data-id="element-85">
                  Oferta de Lanzamiento
                </span>
                <span className="font-serif font-bold text-base md:text-lg leading-tight whitespace-nowrap" data-id="element-86">
                  Acceder por <span className="text-white" data-id="element-87">$14.99</span>
                  <span className="text-white/70 line-through ml-2 text-xs md:text-sm font-sans" data-id="element-88">
                    $27
                  </span>
                </span>
              </div>

              <motion.div animate={{
            x: [0, 4, 0]
          }} transition={{
            duration: 1.6,
            repeat: Infinity,
            ease: 'easeInOut'
          }} className="flex-shrink-0 w-8 h-8 md:w-9 md:h-9 rounded-full bg-white/15 flex items-center justify-center group-hover:bg-white/25 transition-colors" data-id="element-89">
                <ArrowRight size={16} strokeWidth={2.5} data-id="element-90" />
              </motion.div>
            </motion.a>

            <button onClick={() => setIsDismissed(true)} aria-label="Cerrar" className="absolute -top-2 -right-2 w-6 h-6 rounded-full bg-darker border border-border flex items-center justify-center text-foreground/60 hover:text-blood hover:border-blood transition-colors shadow-md" data-id="element-91">
              <X size={12} strokeWidth={2.5} data-id="element-92" />
            </button>
          </div>
        </motion.div>}
    </AnimatePresence>;
}